<template>
  <div class="header-mobile">
    <Transition name="header-menu-slide">
      <div class="header-mobile__header" v-show="isMenuActive || !isHeaderHidden"
           :class="{ 'header-mobile__header_bg-hidden': isMenuActive || isBgHidden }">
        <NuxtLink href="/">
          <img class="header-mobile__logo" alt="Logo" :src="logoUri"/>
        </NuxtLink>
        <button class="header-mobile__menu-button menu-button" @click="isMenuActive = !isMenuActive">
          <img class="menu-button__icon" alt="menu" src="@/assets/images/icons/menu.svg"/>
        </button>
      </div>
    </Transition>
    <Transition name="fade">
      <div class="header-mobile__menu" v-show="isMenuActive">
        <div class="header-mobile__nav-items">
          <NuxtLink
              class="header-mobile__nav-item"
              :class="{ 'header-mobile__nav-item_active': route.path.includes(item.url) }"
              active-class="header-mobile__nav-item_active"
              v-for="item in navItems.filter(item => !item.hidden)"
              :key="item.url"
              :href="item.url"
          >
            {{ item.title }}
          </NuxtLink>
        </div>
        <SocialIcons class="header-mobile__socials"/>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import {useRoute} from "#app";
import defaultLogoUri from "@/assets/images/logo.webp";

const route = useRoute();

export interface HeaderMobileProps {
  navItems: {
    title: string,
    url: string,
    hidden?: boolean,
  }[],
  isHeaderHidden: boolean,
  isBgHidden: boolean,
}

const props = defineProps<HeaderMobileProps>();

const isMenuActive = ref<boolean>(false);

const { getGeneralSettings } = useWebsiteContent();
const { data: generalSettings, suspense: suspenseGeneralSettings } = getGeneralSettings();

const logoUri = computed<string>(() => {
  return generalSettings.value?.logoLight || defaultLogoUri;
});

watch(() => route.path, () => {
  isMenuActive.value = false;
})

await suspenseGeneralSettings();
</script>

<style scoped lang="scss">
.header-mobile {
  isolation: isolate;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;
    z-index: 1;

    padding: 16px 32px;

    background: #0A1129AA;
    backdrop-filter: blur(4px);

    transition: all 200ms ease-out;

    &_bg-hidden {
      background-color: transparent;
      backdrop-filter: none;
    }
  }

  &__menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 64px;

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: #0A1129EE;
  }

  &__logo {
    height: 36px;
  }

  &__nav-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  &__nav-item {
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
    white-space: nowrap;
    text-transform: uppercase;
    text-decoration: none;

    transition: all 200ms ease-out;

    &:hover, &_active {
      color: #E43233;
    }

    @media (max-width: $sm) {
      font-size: 24px;
    }
  }
}

.menu-button {
  background: none;
  outline: none;
  border: none;

  aspect-ratio: 1;
  height: 24px;

  cursor: pointer;

  &__icon {
    display: block;

    width: 100%;
    height: 100%;
  }
}
</style>
